<template>
    <div class="assessment" v-if="domains && simulation && ratingOptions">
        <el-table class="table-responsive table-flush"
                header-row-class-name="thead-light"
                :data="competencies">

            <el-table-column width="200">
                <div slot="header">
                    {{ $t('common.competency-domain') }}
                </div>
                <template v-slot="{row}">
                    <h4 class="mb-0">
                        {{ row.name }}
                        <el-popover placement="top" v-if="row.description">
                            <i slot="reference" class="far fa-question-circle text-muted cursor-pointer ml-1"></i>
                            <div class="pt-2 pr-2 pl-2">
                                <h4>{{ row.name }}</h4>
                                <p class="description mb-0">{{ row.description }}</p>
                            </div>
                        </el-popover>
                    </h4>
                </template>
            </el-table-column>

            <el-table-column>
                <div slot="header">
                    {{ $t('competencies.rating') }} / {{ $t('dashboard.comment') }}
                </div>
                <template v-slot="{row}">

                    <rating
                        :value="row.rating"
                        :options="ratingOptions"
                        :disabled="true"
                        v-if="row.rating != -1 && row.rating !== null"
                    >
                    </rating>
                    
                    <!-- Keep it on the same line -->
                    <p class="description mb-0"
                        :class="{'with-rating': row.rating !== null && row.rating != -1}"
                    >{{row.comment}}</p>
                </template>
            </el-table-column>
            
        </el-table>
    </div>
</template>

<script>
    import Rating from './Rating'

    export default {

        components: {
            Rating
        },

        props: {

            simulation: {
                type: Object,
            },

            registration: {
                type: Object,
            },

            ratingOptions: {
                type: Array,
            },

            domains: {
                type: Array,
            },
        },

        data() {
            return {
                ratings: null,
                comments: null,
                comment: null,
            }
        },

        watch: {

            simulation: {
                immediate: true,
                handler(simulation) {

                    this.ratings = this.domains.reduce((cumulated, domain) => {
                        cumulated[domain.id] = simulation.state.domains && simulation.state.domains[domain.id]
                            ? simulation.state.domains[domain.id]
                            : -1
                        return cumulated
                    }, {})

                    this.comments = this.domains.reduce((cumulated, domain) => {
                        cumulated[domain.id] = simulation.state.domain_comments && simulation.state.domain_comments[domain.id]
                            ? simulation.state.domain_comments[domain.id]
                            : null
                        return cumulated
                    }, {})

                    this.comment = simulation.state.comment
                }
            },
        },

        computed: {
            competencies() {
                let competencies = [{
                    name: this.$t('dashboard.global'),
                    description: '',
                    comment: this.comment,
                    rating: -1
                }]
                for (let index in this.domains) {
                    let domain = this.domains[index]
                    competencies.push({
                        name: this.domainName(domain),
                        description: this.domainDescription(domain),
                        comment: this.comments[domain.id],
                        rating: this.ratings[domain.id]
                    })
                }
                return competencies
            }
        },

        methods: {

            domainName(domain) {
                const nameProp = 'name_' + this.registration.degree.lang
                return domain[nameProp]
            },

            domainDescription(domain) {
                const nameProp = 'description_' + this.registration.degree.lang
                return domain[nameProp]
            },
        }
    }
</script>

<style scoped>

    .description {
        white-space: pre-wrap;
        padding-left: 0;
    }
    .description.with-rating {
        padding-left: 3rem;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .assessment >>> .rating {
        float: left;
    }
    .assessment >>> .rating button {
        width: 30px;
        height: 30px;
    }
    .assessment >>> .el-table::before {
        height: 0 !important;
    }

</style>
